import "core-js/modules/es.number.constructor.js";
export default defineComponent({
  name: 'WatsonIcon',
  props: {
    size: {
      type: Number,
      default: 80
    }
  }
});